import { render } from "./HelloApp.vue?vue&type=template&id=aad5da84&scoped=true"
import script from "./HelloApp.vue?vue&type=script&lang=js"
export * from "./HelloApp.vue?vue&type=script&lang=js"

import "./HelloApp.vue?vue&type=style&index=0&id=aad5da84&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aad5da84"]])

export default __exports__